(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-arrow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getNextShopifySection(el) {
      const currentSection = el.closest('.shopify-section');
      if (!currentSection) return null;

      // Find the next actual Shopify section after this one
      let next = currentSection.nextElementSibling;
      while (next && !next.classList.contains('shopify-section')) {
        next = next.nextElementSibling;
      }
      return next;
    }

    function initScrollArrow(root) {
      const btn = root.querySelector('[data-scroll-arrow-btn]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const nextSection = getNextShopifySection(root);
        if (!nextSection) return;

        // Smooth scroll to the next section
        nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Shopify section lifecycle safe init
    document.querySelectorAll('[data-scroll-arrow]').forEach(initScrollArrow);

    document.addEventListener('shopify:section:load', function (event) {
      const container = event.target;
      if (!container) return;
      container.querySelectorAll('[data-scroll-arrow]').forEach(initScrollArrow);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
